import {
  all,
  call,
  fork,
  put,
  takeEvery,
  takeLatest,
} from "redux-saga/effects";

//Parsing Resume
import {
  ADD_CANDIDATE,
  CANDIDATE_GET_IP_LOCATION,
  CHECK_DUPLICATE_CANDIDATE,
  GET_CANDIDATE_DATA,
  GET_COUNTRIES,
  GET_NATIONALITY,
  GET_QUALIFICATION_STATE,
  GET_SECONDARY_STATE_AND_COUNTRY_DETAILS,
  GET_STATE,
  GET_STATE_AND_COUNTRY_DETAILS,
  PARSING_RESUME,
  PERMANENT_GET_STATE,
  UPDATE_CANDIDATE,
} from "./actionTypes";
import {
  UpdateCandidateFailed,
  UpdateCandidateSuccessful,
  addCandidateFailed,
  addCandidateSuccessful,
  candidateGetIpBasedLocationError,
  candidateGetIpBasedLocationSuccess,
  checkDuplicatesFailed,
  checkDuplicatesSuccessful,
  getCandidateDataFailed,
  getCandidateDataSuccessful,
  getNationalityDataFailed,
  getNationalityDataSuccessful,
  getSecondaryStateAndCountryDetailsFailed,
  getSecondaryStateAndCountryDetailsSuccessful,
  getStateAndCountryDetailsFailed,
  getStateAndCountryDetailsSuccessful,
  parsingResumeFailed,
  parsingResumeSuccessful,
  setCountriesFailed,
  setCountriesSuccess,
  setPermanentStateFailed,
  setPermanentStateSuccess,
  setQualificationStateFailed,
  setQualificationStateSuccess,
  setStateFailed,
  setStateSuccess,
} from "./actions";
//restapi end point
import * as constClass from "../../../common/constant/constantURL";
import {
  checkDuplicateCandidate,
  getAllCounties,
  getCall,
  getIpLocation,
  getStateAndCountry,
  getStates,
  postAddNewCandidate,
  postGetCandidateData,
  postUpdateCandidate,
} from "../../../helpers/fakebackend_helper";

// get resume parsing
function* getParsingResume({ payload: { user } }) {
  try {
    //calling resume parser api

    let url = constClass.REST_API_PARSE_RESUME;

    let responseJSON = yield call(postGetCandidateData, url, user);
    yield put(parsingResumeSuccessful(responseJSON));
  } catch (error) {
    yield put(parsingResumeFailed(error));
  }
}

//Check Duplicate
function* checkDuplicates({ payload: { duplicateCandidate } }) {
  try {
    var url;
    const data = JSON.parse(localStorage.getItem("authUser"));

    if (data.userType === "Recruiter") {
      url = constClass.REST_API_RECRUITER_CHECK_DUPLICATE_CANDIDATE;
    } else {
      url = constClass.REST_API_CHECK_DUPLICATE_CANDIDATE;
    }

    var obj2 = {};
    obj2["duplicate"] = duplicateCandidate;
    let obj1 = {
      type: duplicateCandidate.type,
      email: duplicateCandidate.email,
    };

    if (duplicateCandidate.type === "Update") {
      obj1["candidateId"] = duplicateCandidate.candidateId;
    }
    var responsJSON = yield call(checkDuplicateCandidate, url, obj1);
    yield put(checkDuplicatesSuccessful(responsJSON));
  } catch (error) {
    yield put(checkDuplicatesFailed(error));
  }
}

// get candidate list
function* addCandidates({ payload: { user } }) {
  try {
    var url;
    var data = JSON.parse(localStorage.getItem("authUser"));
    if (data.userType === "Recruiter") {
      url = constClass.REST_API_RECRUITER_ADD_NEW_CANDIDATE;
    } else {
      url = constClass.REST_API_ADD_NEW_CANDIDATE;
    }
    //   var obj={}
    //  var encodedData = base64.encode(utf8.encode(JSON.stringify(obj2)));
    //   let objJsonStr = JSON.stringify(user);
    //   let objJsonB64 = Buffer.from(objJsonStr).toString("base64");
    //   console.log(objJsonB64)
    //   obj["candidate"]=objJsonB64
    //   obj["duplicateUpdate"]=false
    //obj["source"]="direct"
    //calling candidates count api
    var responsJSON = yield call(postAddNewCandidate, url, user);
    yield put(addCandidateSuccessful(responsJSON));
  } catch (error) {
    yield put(addCandidateFailed(error));
  }
}

//Get candidate Data
function* updateCandidates({ payload: { user } }) {
  try {
    var url;
    var data = JSON.parse(localStorage.getItem("authUser"));
    if (data.userType === "Recruiter") {
      url = constClass.REST_API_RECRUITER_UPDATE_CANDIDATE;
    } else {
      url = constClass.REST_API_UPDATE_CANDIDATE;
    }
    //  var obj={}
    //  let objJsonStr = JSON.stringify(user);
    //  let objJsonB64 = Buffer.from(objJsonStr).toString("base64");
    //  obj["candidate"]=objJsonB64
    //  obj["candidateId"]=user.candidateId
    //  obj["source"]="direct"
    //console.log(user)
    //calling candidates count api
    var responsJSON = yield call(postUpdateCandidate, url, user);
    // yield put(getCandidateDataSuccessful(responsJSON))
    yield put(UpdateCandidateSuccessful(responsJSON));
  } catch (error) {
    yield put(UpdateCandidateFailed(error));
  }
}
//Get candidate Data
function* getCandiateData({ payload }) {
  try {
    console.log("=== SAGA getCandiateData ===");
    console.log("Full payload:", payload);

    const { user } = payload;

    let url;
    let data = JSON.parse(localStorage.getItem("authUser"));

    if (data.userType === "Recruiter") {
      url = constClass.REST_API_GET_RECRUITER_CANDIDATE_DATA;
    } else {
      url = constClass.REST_API_GET_CANDIDATE_DATA + `?id=${user}`;
    }

    console.log("Final URL:", url);

    let obj = {};
    obj["candidateId"] = user;
    let obj2 = {};
    obj2["candidate"] = obj;
    let responsJSON = yield call(getCall, url);

    console.log("=== API Response Received ===");
    console.log("Full response:", responsJSON);
    console.log("\n--- Checking Arrays ---");
    console.log("experiences:", responsJSON.experiences);
    console.log(
      "experiences length:",
      responsJSON.experiences
        ? responsJSON.experiences.length
        : "NULL/UNDEFINED",
    );
    console.log("\nqualifications:", responsJSON.qualifications);
    console.log(
      "qualifications length:",
      responsJSON.qualifications
        ? responsJSON.qualifications.length
        : "NULL/UNDEFINED",
    );
    console.log("\ncertifications:", responsJSON.certifications);
    console.log(
      "certifications length:",
      responsJSON.certifications
        ? responsJSON.certifications.length
        : "NULL/UNDEFINED",
    );
    console.log("\nachievements:", responsJSON.achievements);
    console.log(
      "achievements length:",
      responsJSON.achievements
        ? responsJSON.achievements.length
        : "NULL/UNDEFINED",
    );
    console.log("\nskills:", responsJSON.skills);
    console.log(
      "skills length:",
      responsJSON.skills ? responsJSON.skills.length : "NULL/UNDEFINED",
    );

    yield put(getCandidateDataSuccessful(responsJSON));
  } catch (error) {
    console.error("Error in getCandiateData saga:", error);
    yield put(getCandidateDataFailed(error));
  }
}

//Get Nationality
function* getNationalityData() {
  try {
    var url = constClass.REST_API_GET_NATIONALITY;
    //calling candidates count api
    var responsJSON = yield call(getCall, url);
    yield put(getNationalityDataSuccessful(responsJSON));
  } catch (error) {
    yield put(getNationalityDataFailed(error));
  }
}
function* getCountries() {
  try {
    var url = constClass.REST_API_GET_COUNTRIES;

    const response = yield call(getAllCounties, url);

    yield put(setCountriesSuccess(response));
  } catch (error) {
    yield put(setCountriesFailed(error));
  }
}
function* getState({ payload: { user } }) {
  try {
    var url = constClass.REST_API_GET_STATE;

    const response = yield call(getStates, url, user);

    yield put(setStateSuccess(response));
  } catch (error) {
    yield put(setStateFailed(error));
  }
}

function* getCity({ payload: { city } }) {
  try {
    var url = constClass.REST_API_GET_STATE_AND_COUNTRY;
    const response = yield call(getStateAndCountry, url + `?city=${city}`);
    yield put(getStateAndCountryDetailsSuccessful(response));
  } catch (error) {
    yield put(getStateAndCountryDetailsFailed(error));
  }
}

function* getsecondaryCity({ payload: { city } }) {
  try {
    var url = constClass.REST_API_GET_STATE_AND_COUNTRY;

    const response = yield call(getStateAndCountry, url + `?city=${city}`);
    yield put(getSecondaryStateAndCountryDetailsSuccessful(response));
  } catch (error) {
    yield put(getSecondaryStateAndCountryDetailsFailed(error));
  }
}

function* getIplocation() {
  try {
    var url = constClass.REST_API_GET_IP_LOCATION;

    const response = yield call(getIpLocation, url);

    yield put(candidateGetIpBasedLocationSuccess(response));
  } catch (error) {
    yield put(candidateGetIpBasedLocationError(error));
  }
}
function* getPermanentState({ payload: { user } }) {
  try {
    var url = constClass.REST_API_GET_STATE + user;

    const response = yield call(getStates, url, user);

    yield put(setPermanentStateSuccess(response));
  } catch (error) {
    yield put(setPermanentStateFailed(error));
  }
}

function* getQualficationState({ payload: { user } }) {
  try {
    var url = constClass.REST_API_GET_STATE + user;

    const response = yield call(getStateAndCountry, url);

    yield put(setQualificationStateSuccess(response));
  } catch (error) {
    yield put(setQualificationStateFailed(error));
  }
}

export function* watchParsingResume() {
  yield takeEvery(PARSING_RESUME, getParsingResume);
  yield takeLatest(CHECK_DUPLICATE_CANDIDATE, checkDuplicates);
  yield takeEvery(ADD_CANDIDATE, addCandidates);
  yield takeEvery(GET_CANDIDATE_DATA, getCandiateData);
  yield takeEvery(UPDATE_CANDIDATE, updateCandidates);
  yield takeEvery(GET_NATIONALITY, getNationalityData);
  yield takeLatest(GET_COUNTRIES, getCountries);
  yield takeLatest(GET_STATE, getState);
  yield takeEvery(CANDIDATE_GET_IP_LOCATION, getIplocation);
  yield takeEvery(PERMANENT_GET_STATE, getPermanentState);
  yield takeEvery(GET_QUALIFICATION_STATE, getQualficationState);
  yield takeLatest(GET_STATE_AND_COUNTRY_DETAILS, getCity);
  yield takeEvery(GET_SECONDARY_STATE_AND_COUNTRY_DETAILS, getsecondaryCity);
}

function* parsingResumeSaga() {
  yield all([fork(watchParsingResume)]);
}

export default parsingResumeSaga;
